(() => {
   angular
    .module('app')
    .controller('host.views.panelRecruitment.mergePanelRequestsModal', MergePanelRequestsModalController);

  MergePanelRequestsModalController.$inject = [
    '$scope',
    '$uibModalInstance',
    'abp.services.app.panelRequest',
    'requestNumber'
  ];

  function MergePanelRequestsModalController(
    $scope,
    $uibModalInstance,
    panelRequestSvc,
    requestNumber
  ) {
    const vm = this;

    vm.loading = 0;
    vm.saving = 0;
    vm.confirmMerge = null;
    vm.mainPanelRequest = null;
    vm.panelRequests = [];
    vm.requestsToMerge = [];
    vm.dissimilarRequests = [];

    vm.save = save;

    init();

    function init() {
      fetchPanelRequests();
    }

    function fetchPanelRequests() {
      vm.loading += 1;
      panelRequestSvc
        .getPanelRequestForMerging({ id: requestNumber })
        .success((data) => {
          vm.mainPanelRequest = data.mainPanelRequest;
          vm.panelRequests = data.mergeablePanelRequests;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function save() {
      if (vm.saving || !App.isFormValid($scope.mergePanelRequestsForm)) {
        return;
      }

      vm.saving += 1;

      abp.message.confirm(
        App.localize('MergeXConfirmMessage', vm.mainPanelRequest.requestNumber),
        App.localize('AreYouSure'),
        (confirmed) => {
          if (confirmed) {
            panelRequestSvc
              .mergePanelRequests({
                mainRequestNumber: vm.mainPanelRequest.requestNumber,
                requestNumbersForMerge: _.map(vm.requestsToMerge, 'requestNumber'),
              })
              .success(() => {
                abp.notify.info(App.localize('SuccessfullySaved'));
                $uibModalInstance.close();
              })
              .finally(() => {
                vm.saving -= 1;
              });
          } else {
            vm.saving -= 1;
          }
        }
      );
    };

    // A simple similarity check to help operator identify request that may not be the same.

    vm.checkSimilarity = function checkSimilarity() {
      vm.dissimilarRequests = _.filter(
        vm.requestsToMerge,
        (request) => request.panelName !== vm.mainPanelRequest.panelName
      );
    };

    vm.cancel = function cancel() {
      $uibModalInstance.dismiss();
    };
  }
})();
